$(document).ready(function(){

    $('.masktele').inputmask("+7 999 999-9999", {
        clearIncomplete: false,
        showMaskOnHover: false
    });

    jQuery.validator.addMethod("checkMask", function(value, element) {
        return /\+\d{1} \d{3} \d{3}-\d{4}/g.test(value);
    });

    $('.ajax__form').each(function() {
        $(this).validate({
            wrapper: '.js-errors',
            focusInvalid: false,
            rules: {
                phone: {
                    checkMask: true
                }
            },
            submitHandler: function(form) {
                let t = $(form),
                    action = t.attr('action'),
                    formData = t.serialize();
                $.ajax({
                    type: "POST",
                    url: ajaxurl,
					data: formData + '&action=send_email', // Добавляем действие,
                    dataType: 'json',
                    success: function (response) {
                        try {                            
                            t[0].reset();
                            // $.fancybox.close();
                            // $.fancybox.open({
                            //     src  : '#thanks',
                            //     type : 'inline'
                                
                            // });
							window.location.href = '/spasibo/';
                        }
                        catch (e) {
                            console.log(response);
                        }
                    }
                });
                return false;
            }
        });
    });

    var swiperMain = new Swiper('.slider-main', {
        loop: true,
        speed: 350,
        pagination: {
            el: '.main-pagination',
            dynamicBullets: true,
            clickable: true,
        },
        navigation: {
            nextEl: '.main-next',
            prevEl: '.main-prev',
        },
    });

	var swiperServices = new Swiper('.slider-services', {
		loop: true,
		speed: 350,
		pagination: {
			el: '.services-pagination',
			dynamicBullets: true,
			clickable: true,
		},
		navigation: {
			nextEl: '.services-arrow-next',
			prevEl: '.services-arrow-prev',
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 10,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 50,
			},
			1920: {
				slidesPerView: 4,
				spaceBetween: 50,
			}
		}
	});
	

	var swiperPopular = new Swiper('.slider-popular', {
        loop: true,
        
        initialSlide: 2,
        speed: 350,
        pagination: {
            el: '.services-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.popular-services-next',
            prevEl: '.popular-services-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
			1200: {
                slidesPerView: 4,
                spaceBetween: 50,
			}
        }
    });

	if ($('.slider-popular .swiper-slide').length <= 4) {
		$('.slider-popular .swiper-wrapper').addClass('disabled');
		$('.slider-popular .popular-services-prev, .slider-popular .popular-services-next').css('display', 'none')
	}

	var swiperReviews = new Swiper('.slider-reviews', {
        loop: false,
        

        speed: 350,
        pagination: {
            el: '.services-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.services-arrow-next',
            prevEl: '.services-arrow-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
                centeredSlides: true,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 50,
            }
        }
    });

	$('.services-reviews__stars').each(function() {
		var mark = $(this).data('mark');
		for (var i = 1; i <= 5; i++) {
		  if (i > mark) {
			$(this).children('img:nth-child(' + i + ')').hide(); 
		  } 
		}
	});

    var swiperGallery = new Swiper('.slider-gallery', {
        loop: true,
        speed: 350,
        pagination: {
            el: '.gallery-pagination',
            dynamicBullets: true,
            clickable: true,
        },
        navigation: {
            nextEl: '.gallery-next',
            prevEl: '.gallery-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 50,
            }
        }
    });




    $('.tab').on('click', function(){
        let tab = $(this).data('tab');

        $('.tab').removeClass('active');
        $('.tabs__content').removeClass('active');

        $(this).addClass('active');
        $(tab).addClass('active');
    })

    $('.mobile-menu').click(function(){
        $(this).toggleClass('is-active');
        $('.header__info').toggleClass('active');
    })

	$('[data-src="#consultation"]').click(function(){
		let title = $(this).data('title'),
			btnText;

		if (title) {
			$('.input-title').val(title);
		}

		if ($(this).hasClass('.slider__item-btn')) {
			btnText = $(this).find('.text').text();
		} else {
			btnText = $(this).text();
		}

		$('.btn-text').val(btnText);


		

	})

	$('.menu-item-has-children').each(function () {
		if ($(this).find('.menu-item-has-children').length) {
			$(this).find('.sub-menu').addClass('sub-menu-has-children');
		} else {
			$(this).find('.sub-menu').addClass('sub-menu-no-children')
		}
	});

	if ($(window).width() <= 990) {

		const AllServicesData = $('.header__menu a').first().clone().css('font-weight', '500').text('Все услуги')
		const AllServicesList = $('.header__menu .sub-menu-has-children').first();
		
		AllServicesList.append(AllServicesData);
		

		$('.header__menu > .menu-item-has-children > a').on('click', function (e) {
			e.preventDefault();
			var $this = $(this);
	
			if ($this.hasClass('active')) {
				$this.removeClass('active').next('ul').slideUp(300);
			} else {
				$('.header__menu > .menu-item-has-children > a').removeClass('active').next('ul').slideUp(300);
				$this.addClass('active').next('ul').slideDown(300);
			}
		});
	
		$('.header__menu .menu-item-has-children .menu-item-has-children > a').on('click', function (e) {
			e.preventDefault();
			var $this = $(this);
	
			if ($this.hasClass('active')) {
				$this.removeClass('active').next('ul').slideUp(300);
			} else {
				$('.header__menu .menu-item-has-children .menu-item-has-children > a').removeClass('active').next('ul').slideUp(300);
				$this.addClass('active').next('ul').slideDown(300);
			}
		});

	}

	// Логика меню в шапке

	$('.header__menu .menu-item a').on('click', function(e) {
		var headerHeight = $('.header').outerHeight();
		var targetId = $(this).attr('href');


		if (targetId.startsWith('/#')) {
			e.preventDefault(); 
			var targetElementId = targetId.slice(2); 

			if (window.location.pathname !== '/') {

				window.location.href = '/' + '#' + targetElementId;
			} else {
	
				var $targetElement = $('#' + targetElementId);

				if ($targetElement.length) {
					var targetPosition = $targetElement.offset().top;

					$('.mobile-menu').removeClass('is-active');
					$('.header__info').removeClass('active');

					$('html, body').animate({
						scrollTop: targetPosition - headerHeight
					}, 800);
				}
			}
		}
	});

});

ymaps.ready(function() {
    // Цикл по массиву данных карт
    mapsData.forEach(function(mapData) {
        // Создаем карту
        let myMap = new ymaps.Map(mapData.elementId, {
            center: mapData.center,
            zoom: 18
        });

        // Создаем метку
        let myPlacemark = new ymaps.Placemark(mapData.placemarkCoords, {}, {
            iconLayout: 'default#image',
            iconImageHref: '/wp-content/themes/proauto/img/marker.svg',
            iconImageSize: [32, 48],
            iconImageOffset: [-16, -48]
        });

        // Добавляем метку на карту
        myMap.geoObjects.add(myPlacemark);
    });
});

/* Получение постов на главной при клике на таб */

jQuery(document).ready(function($) {
    let page = 1;
    let currentCategoryId = 4;

    $('.category-link').on('click', function(e) {
        e.preventDefault();

        currentCategoryId = $(this).data('category-id');
        page = 1;

        $('.services__items').fadeOut(200, function() {
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'load_services_by_category',
                    category_id: currentCategoryId
                },
                success: function(response) {
                    $('.services__items').html(response);
                    $('.services__items').hide().fadeIn(200);
					if ($('.services__card').length <= 6) {
                        $('.show-more-btn-wrapper').hide();
                    } else {
                        $('.show-more-btn-wrapper').show();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX error: ' + textStatus + ' : ' + errorThrown);
                }
            });
        });
    });

	$('.category-link-slider').on('click', function (e) {
        e.preventDefault();
        var categoryId = $(this).data('category-id');
        
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'load_services_slider',
                category_id: categoryId
            },
            beforeSend: function () {
                $('.swiper-wrapper').html('<div class="loading">Загрузка контента</div>');
            },
            success: function (response) {
                $('.swiper-wrapper').html(response);
				if (typeof swiperServices !== 'undefined') {
					swiperServices.destroy(true, true);
				}

				swiperServices = new Swiper('.slider-services', {
					loop: true,
					speed: 350,
					pagination: {
						el: '.services-pagination',
						dynamicBullets: true,
						clickable: true,
					},
					navigation: {
						nextEl: '.services-arrow-next',
						prevEl: '.services-arrow-prev',
					},
					breakpoints: {
						0: {
							slidesPerView: 1,
							spaceBetween: 5,
						},
						576: {
							slidesPerView: 2,
							spaceBetween: 30,
						},
						1200: {
							slidesPerView: 3,
							spaceBetween: 50,
						},
						1920: {
							slidesPerView: 4,
							spaceBetween: 50,
						}
					}
				});


            },
            error: function () {
                alert('Что-то пошло не так, попробуйте снова.');
            }
        });
    });



	$('.show-more-btn-wrapper .show-more').on('click', function(e) {
		e.preventDefault();
	
		page++;
	
		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: {
				action: 'load_more_services',
				category_id: currentCategoryId,
				page: page,
				posts_per_page: 12
			},
			success: function(response) {
				if (response.trim() === '') {
					$('.show-more-btn-wrapper').hide();
				} else {
					$('.services__items').append(response);
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log('AJAX error: ' + textStatus + ' : ' + errorThrown);
				console.log(jqXHR.responseText);
			}
		});
	});

	$('.services .container.services__categories li').first().addClass('active');

	$('.services .container.services__categories li').on('click', function (){
		$(this).addClass('active').siblings().removeClass('active');
	})
	
});


$(document).ready(function() {
    var totalSteps = $('.quiz-step').length; // Количество шагов
    var currentStep = 1; // Текущий шаг
    
    // Функция для обновления прогресса
    function updateProgress() {
        var progressPercent = (currentStep / totalSteps) * 100;
        $('.quiz-progress-current').css('width', progressPercent + '%');
        $('.quiz-progress-runner').text(currentStep + ' / ' + totalSteps);
        $('.quiz-progress-runner').removeClass('last');

        if (currentStep == totalSteps) {
            $('.quiz-progress-runner').addClass('last');
        }
    }

	function focusOnInput() {
        var activeStep = $('.quiz-step.active');
        var firstInput = activeStep.find('.input-text');
        
		console.log(firstInput);
        if (firstInput.length) {
            setTimeout(function() {
                firstInput.focus(); 
            }, 200); 
        }
    }
    
    // Следующий шаг
    function goToNextStep() {
        if (currentStep < totalSteps) {
            // Обновление классов для шагов
            var currentStepElement = $('.quiz-step.active');
            currentStepElement.removeClass('active').addClass('prev');
            currentStepElement.next().removeClass('next').addClass('active');
            
            // Увеличиваем текущий шаг
            currentStep++;
            updateProgress();
			focusOnInput();
        } else {
            // Если последний шаг, то форма отправляется
            $('.quiz-form').submit();  // отправляем форму
        }
    }

    // Предыдущий шаг
    function goToPrevStep() {
        if (currentStep > 1) {
            // Обновление классов для шагов
            var currentStepElement = $('.quiz-step.active');
            currentStepElement.removeClass('active').addClass('next');
            currentStepElement.prev().removeClass('prev').addClass('active');
            
            // Уменьшаем текущий шаг
            currentStep--;
            updateProgress();
			focusOnInput();
        } else {
            $('.quiz').removeClass('show');
            $('body').removeClass('blocked');
        }
    }

    // Обработка клика по кнопке "Далее"
    $('.quiz-btns-next').click(function(e) {
        e.preventDefault();
        goToNextStep();
    });

    // Обработка клика по кнопке "Назад"
    $('.quiz-btns-prev').click(function(e) {
        e.preventDefault();
        goToPrevStep();
    });

    // Поддержка нажатия клавиши "Enter" для перехода к следующему шагу
    $(document).keypress(function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();  // Предотвращаем стандартное поведение "Enter"
            
            if (currentStep < totalSteps) {
                // Если не последний шаг, переходим к следующему шагу
                goToNextStep();
            } else {
                // Если последний шаг, сабмит формы
                $('.quiz-form').submit();
            }
        }
    });

    $('.quiz-close').click(function(){
        $('.quiz').fadeOut(900);
		$('body').css('overflow', 'visible');
    });

    // Инициализируем начальный прогресс
    updateProgress();
	

	setTimeout(function(){
		$('.quiz').fadeIn(900);
		$('body').css('overflow', 'hidden');
		focusOnInput();
	}, 90000);
	

    // Стрелка вверх

    $(window).scroll(function () {
        if ($(this).scrollTop() >= 600) {
            $('.btn-black-arrow').addClass('show');
        } else {
            $('.btn-black-arrow').removeClass('show')
        }
    });

    $('.btn-black-arrow').on('click', function (){
        $('html, body').animate({ scrollTop: 0}, 'slow');
    });

    // Активные пункты меню

    const menuItems = $('.header__menu li');
    const sections = $("section");

    menuItems.each(function() {
        if ($(this).find('a').attr('href').startsWith('/#')) {
            $(this).removeClass('current-menu-item');
        }
    });

    $(window).scroll(function () {
        let currentSection = "";

        sections.each(function() {
            const sectionTop = $(this).offset().top;
            const sectionHeight = $(this).outerHeight();

            if ($(window).scrollTop() >= sectionTop - sectionHeight / 3) {
                currentSection = $(this).attr("id"); 
            }
            
            menuItems.each(function() {
                const link = $(this).find("a");
                if (link.attr("href") === `/#${currentSection}`) {
                    $(this).addClass("current-menu-item");
                } else {
                    $(this).removeClass("current-menu-item");
                }
            });
        });

    });

    // Вопросы и ответы

    $('.accordion').on('click', function() {
        $(this).find('img').toggleClass('show');
        $(this).find('.accordion-content').slideToggle()
        $(this).siblings().find('.accordion-content').slideUp();
        $(this).siblings().find('img').removeClass('show');
    });

    /* Скроллер кнопка в подменю на ПК версии */

    if ($(window).width() >= 991) {
        $('.header__menu > li.menu-item-has-children > .sub-menu').append('<div class="btn btn-black btn-black-arrow-bottom"><img src="/wp-content/themes/proauto/img/arrow-bottom-white.svg"></div>');

        $('.header__menu > li.menu-item-has-children > .sub-menu .btn-black-arrow-bottom').on('click', function() {
            var headerScrollableSubmenu = $('.header__menu > li.menu-item-has-children > .sub-menu');
            headerScrollableSubmenu.scrollTop(headerScrollableSubmenu[0].scrollHeight);
            $(this).fadeOut(300);
            
        });
    }

});




